import { t } from "i18next";
import type { ICustomField } from "store/customFieldsStore";

export const mandatoryAccountFieldsName = {
    street: t("NewBeneficiary.StreetNumber"),
    siretNumber: t("BeneficiarInfo.Siret"),
    socialSecurityNumber: t("BeneficiarInfo.SecurityNumber"),
    city: t("NewBeneficiary.City"),
    zipCode: t("NewBeneficiary.ZIPCode"),
    name: t("NewBeneficiary.Name"),
    surname: t("NewBeneficiary.Surname"),
    phoneNumber: t("NewBeneficiary.PhoneNumber"),
};

/**
 * Format missing mandatory fields names
 * @param { ICustomField[] } emptyCustomFields empty mandatory custom fields
 * @param { strings[] } emptyFields empty mandatory native fields
 */
export const getMissingFieldsNames = (emptyCustomFields: ICustomField[] | undefined, emptyFields?: string[]) => {
    const missingFields: string[] = [];
    if (emptyFields) {
        emptyFields.forEach((fieldName) => missingFields.push(mandatoryAccountFieldsName[fieldName]));
    }
    emptyCustomFields?.forEach((field) => missingFields.push(field.name));
    return missingFields;
};
